// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"cff9d1df","488":"c69c4dfb"}[chunkId] + ".chunk.js";
};